import { memo } from 'react';
import { StatBox } from '../../../components/ui/stat-box';
import { ProgressCircle } from '../../../components/ui/progress-circle';
import { Upload, X, Check } from 'lucide-react';
import { useUploadContext } from './upload-provider';

const TotalFilesStatInner = memo(function TotalFilesStat() {
  const { meta } = useUploadContext();
  const { stats } = meta;

  return (
    <StatBox
      title="Total de arquivos recebidos hoje"
      value={stats.total}
      icon={<Upload className="h-6 w-6 text-primary" />}
    />
  );
});

const ErrorFilesStatInner = memo(function ErrorFilesStat() {
  const { meta } = useUploadContext();
  const { stats } = meta;

  return (
    <ProgressCircle
      title="Arquivos com Erro"
      value={stats.errorCount}
      percentage={stats.errorPercentage}
      icon={<X className="h-6 w-6 text-destructive" />}
    />
  );
});

const SuccessFilesStatInner = memo(function SuccessFilesStat() {
  const { meta } = useUploadContext();
  const { stats } = meta;

  return (
    <ProgressCircle
      title="Arquivos processados"
      value={stats.successCount}
      percentage={stats.successPercentage}
      icon={<Check className="h-6 w-6 text-green-600" />}
    />
  );
});

export const UploadStats = {
  TotalFiles: TotalFilesStatInner,
  ErrorFiles: ErrorFilesStatInner,
  SuccessFiles: SuccessFilesStatInner,
};
